import { email, maxLength, propertyMapping, required } from '@hakla/typed-forms'
import { OrganisationResponse, ResourceVariant } from '@/api/generated'
import { updateOrAppend } from '@/shared/utils/list'
import { compareBy } from '@/shared/utils/compare-by'

export interface OrganisationForm {
  categories: string[]
  description?: string
  email: string
  id?: number
  location?: string
  logo: ResourceVariant
  name: string
  sector?: string
  shortDescription?: string
  type?: string
  visible: boolean
  vision?: string
  website?: string
}

export function organisationFormMapping() {
  return propertyMapping<OrganisationResponse, OrganisationForm>(({ generic }) => {
    return {
      categories: generic('categories'),
      description: generic('description'),
      email: generic('email').validations(email, required),
      id: generic('id'),
      location: generic('location'),

      logo: generic('logo')
        .deserializeWith(value => {
          return value.resources.find(resource => resource.name === 'logo')?.resources[0]
        })
        .serializeWith((model, form) => {
          model.resources = updateOrAppend(
            model.resources,
            { name: 'logo', resources: [form.logo] },
            compareBy('name')
          )
        }),

      name: generic('name').validations(required),
      sector: generic('sector'),
      shortDescription: generic('shortDescription').validations(maxLength(350)),
      type: generic('type'),
      vision: generic('vision'),
      visible: generic('visible'),
      website: generic('website'),
    }
  })
}
